// src/encounter/intelligence/ask-words.ts
//
// The Ask card's fixed words. The state lines are Antonin's catalog sentences (scrips-signal-ds feat/signal,
// IntelligenceRail/rail-data.ts T), quoted, never rephrased; the engine's own messages are never shown.
import { SESSION_EXPIRED } from './explanation';
import type { RunCardState } from './run-card-state';

export interface AskRequest { question: string; seq: number }
/** The free Ask goes to the state interpreter (encounter owner, 1 Nov 2026). */
export const ASK_AGENT = { agent: 'state-interpreter', actionKind: 'state.interpret' } as const;

export const ASK_WORDS = {
  title: 'Ask',
  origin: 'AI draft · review before use',
  how: 'How this was produced',
  loading: 'Reading the record and checking the answer…',
  review: 'Suggestion and evidence not yet reviewed by a clinician.',
  stop: 'Stop',
  retry: 'Retry',
  maxLength: 500,
} as const;

/** The one line a card in each state shows, never the engine's text. */
export const ASK_STATE_LINE: Partial<Record<RunCardState, string>> = {
  withheld: 'Withheld: a check did not pass. Open the results list.',
  'run-failed': 'The AI check could not run. Retry.',
  timeout: 'Scrips Intelligence did not answer in time. The visit continues without it.',
  busy: 'Scrips Intelligence is busy. Try again in a moment.',
  denied: 'Not available for your role.',
  'could-not': 'Could not answer. Try again.',
  down: 'Scrips Intelligence is not available. The visit continues without it.',
  'session-expired': SESSION_EXPIRED,
};

/** Encounter owner, 4 Nov 2026: a withheld answer says why in plain words. The engine's fixed sentences (runDelivery.ts
 *  WITHHELD_PLAIN); only these are ever shown, any other text falls back to the catalog line. */
export const WITHHELD_PLAIN: readonly string[] = [
  'Not answered: the record read does not show this.',
  'Not answered: a line was not supported by the record.',
  'Not answered: the draft broke a wording rule.',
  'Not answered: the checks did not finish.',
  'Not answered: no answer came back.',
];

/** The trace's step names, as the catalog's "How this was produced" checks name them. */
export const CHECK_NAME = { rules: 'Wording check against the house rules', fast: 'AI check that each line matches its cited record items', judge: 'AI check against the clinical house rules' } as const;
